<script setup lang="ts">
import type { PlayerStatistic } from '@acepoker/contract'
import ScoreInfo from './ScoreInfo.vue'

const props = defineProps<{ statistic: PlayerStatistic; size?: 'small' | 'large' }>()
</script>

<template>
  <div
    class="flex flex-col justify-center items-center bg-dark-grey w-full rounded-lg desktop:rounded-[8px] p-3.5 desktop:p-[16px] mb-3.5"
  >
    <div class="text-white text-base font-semibold mb-4 w-full">Action Analysis</div>
    <div class="flex flex-wrap w-full">
      <ScoreInfo
        :size="props.size"
        :value="props.statistic.handsTotal / props.statistic.sessions"
        :title="$t('Statistic.label.HandsPlayed')"
      />
      <ScoreInfo
        :size="props.size"
        :value="props.statistic.handsTotal"
        :title="$t('Statistic.label.TotalHands')"
      />
      <ScoreInfo
        :size="props.size"
        :value="
          props.statistic.totalEVLoss.toFixed(
            statistic.totalEVLoss === 0 ? statistic.totalEVLoss : 2
          )
        "
        :title="$t('Statistic.label.TotalEV')"
      />
      <ScoreInfo
        :size="props.size"
        :value="
          props.statistic.avgEVLoss.toFixed(statistic.avgEVLoss === 0 ? statistic.avgEVLoss : 2)
        "
        :title="$t('Statistic.label.AvgEV')"
      />
    </div>
  </div>
</template>
